import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=1215ad15&scoped=true"
import script from "./Top.vue?vue&type=script&lang=ts"
export * from "./Top.vue?vue&type=script&lang=ts"
import style0 from "./Top.vue?vue&type=style&index=0&id=1215ad15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215ad15",
  null
  
)

export default component.exports